module.exports = __webpack_public_path__ + "static/70gde-3cc204578539b73a98f2fd757b65cc1e.gif";